import { forwardRef } from "react";

import {
  type TNavigationMenuSeparatorProps,
} from "@/ui/components/navigation/NavigationMenu/NavigationMenu.config";
import { cn } from "@/ui/lib/utils";

export const NavigationMenuSeparator = forwardRef<
  HTMLLIElement,
  TNavigationMenuSeparatorProps
>(({ className, orientation = "horizontal", ...props }, ref) => (
  <li
    ref={ref}
    role="separator"
    aria-orientation={orientation}
    data-component="NavigationMenuSeparator"
    className={cn(
      "shrink-0 bg-component-dropdownMenu-separator",
      orientation === "horizontal" ? "h-px w-full" : "h-6 w-px",
      className,
    )}
    {...props}
  />
));

NavigationMenuSeparator.displayName = "NavigationMenuSeparator";
